module.exports = __webpack_public_path__ + "img/tutorial-edit.58223a71.png";